module.exports = require("@swa-ui/hotel/src/components/HotelBookingForm/HotelBookingForm.module.scss");